@let times = splitTimes();

<span class="cart-times-display">
  @if (times.visible.length) {
    @for (time of times.visible; track $index) {
      <span class="cart-times-display__entry">{{ $index === times.visible.length - 1 ? time : `${time},` }}</span>
    }
    @if (times.truncated.length > 0) {
      <em
        class="cart-times-display__entry"
        tabindex="0"
        ftrTooltip
        [template]="truncatedTimes"
        alignment="auto"
        position="above"
        [showDash]="false"
      >
        + {{ times.truncated.length }} timeframe{{ times.truncated.length === 1 ? '' : 's' }}
      </em>
      <ng-template #truncatedTimes>
        @for (time of times.truncated; track $index) {
          <div>{{ time }}</div>
        }
      </ng-template>
    }
  }
</span>
